import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import { Entity, SimpleResource } from "@rest-hooks/rest";
import {
	LienEntity,
	ApplicationPropertyEntity
} from "../entities/ApplicationPropertyEntities";
import { ApplicationMortgageERegistrationEntity } from "../entities/ApplicationMortgageERegistrationEntity";

export interface ApplicationCustomerAsHouseOwner {
	readonly personalNumber?: string;
	readonly name?: string;
	readonly email?: string;
	readonly phone?: string;
	readonly isResident?: boolean;
	readonly propertyInformation?: string;
}

export class ApplicationCustomerAsHouseOwnerEntity
	extends Entity
	implements ApplicationCustomerAsHouseOwner
{
	constructor() {
		super();
		this.personalNumber = "";
		this.name = "";
		this.email = "";
		this.phone = "";
		this.isResident = false;
		this.propertyInformation = "";
	}

	readonly personalNumber?: string = "";
	readonly name?: string = "";
	readonly email?: string = "";
	readonly phone?: string = "";
	readonly isResident?: boolean = false;
	readonly propertyInformation?: string = "";

	pk(parent?: any, key?: string) {
		return this.personalNumber || "";
	}
}

interface PropertyERegistrationOverview {
	readonly applicationId?: number;
	readonly properties?: ApplicationPropertyEntity[];
	readonly liens?: LienEntity[];
	readonly owners?: ApplicationCustomerAsHouseOwnerEntity[];
	readonly mortgageRegistration?: ApplicationMortgageERegistrationEntity;
}

export class PropertyERegistrationOverviewResource
	extends BaseCamelCasedResource
	implements PropertyERegistrationOverview
{
	constructor() {
		super();
		this.applicationId = 0;
		this.properties = [];
		this.liens = [];
		this.owners = [];
		this.mortgageRegistration = ApplicationMortgageERegistrationEntity.fromJS();
	}

	readonly applicationId?: number = 0;
	readonly properties?: ApplicationPropertyEntity[] = [];
	readonly mortgageRegistration?: ApplicationMortgageERegistrationEntity =
		undefined;
	readonly liens?: LienEntity[] = [];
	readonly owners?: ApplicationCustomerAsHouseOwnerEntity[] = [];

	static schema = {
		properties: [ApplicationPropertyEntity],
		liens: [LienEntity],
		owners: [ApplicationCustomerAsHouseOwnerEntity],
		mortgageRegistration: new ApplicationMortgageERegistrationEntity()
	};

	pk(parent?: any, key?: string | undefined): string | undefined {
		return this.applicationId?.toString() || "";
	}

	static urlRoot = apiResourceUrl("property-eregistration-overview");
	static urlTemplates = [`${this.urlRoot}/{applicationId}`];

	static url<T extends typeof SimpleResource>(
		this: T,
		urlParams: Readonly<Record<string, any>>
	) {
		const { applicationId, ...searchParams } = urlParams;

		const url = super.url(urlParams);
		return url;
	}
}
